/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uk_Email_Mp_DescriptionInputs */

const en_uk_email_mp_description = /** @type {(inputs: Uk_Email_Mp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact your Member of Parliament about AI safety`)
};

/**
* | output |
* | --- |
* | "Contact your Member of Parliament about AI safety" |
*
* @param {Uk_Email_Mp_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const uk_email_mp_description = /** @type {((inputs?: Uk_Email_Mp_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uk_Email_Mp_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_uk_email_mp_description(inputs)
});